import { render } from "./AboutUsView.vue?vue&type=template&id=020d78c0"
const script = {}

import "./AboutUsView.vue?vue&type=style&index=0&id=020d78c0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__